<template>

  <div  @click="click" :class="cardClass+' '+fullStyle" :style="'width:'+(docWidth)+'px; height:'+(docHeight)+'px'">
    <div class="drag">{{document.name}}</div>
     <slot></slot>
    <div style="margin-top:5px;width:calc(100% - 10px);padding:10px;">
 {{document.description}}
  
  
   </div>
  
 
  </div>
</template>

<script>



import DocScanner from "@/components/DocScanner.vue";

export default {
  components:{
  
   DocScanner,
  
 
  },
  props: {
    cardClass:{default:"evidenceCard"},
    card:null,
    index:null,
    resizeCallback:null,
    selected:{default:false}
  },
  data() {
    return {
      fullSize:false,
       mapVis:false,
       isActive:true,
       style:"opacity:.9;border:none;text-transform: uppercase;margin-auto"
  
    };
  },
  computed: {
    windowHeight(){
      return window.innerHeight-200
    },
    windowWidth(){
      return window.innerWidth-100
    },
    docRatio(){
      
      return 1
    },
    docScale(){
      let sh=this.windowHeight/this.docSize.height
      let sw=this.windowWidth/this.docSize.width
      return Math.min(sh,sw)
    },
    docSize(){
      
      return {width:600,height:800}
    },
    docWidth(){
      
      if(this.fullSize){
        return this.docSize.width*this.docScale
      }else{
        return 300
      }
    },
    docHeight(){
      if(this.fullSize){
       return Math.floor(this.docWidth/this.docRatio)
      }else{
        return 300
      }
    },
    fullStyle(){
      if(this.fullSize){
        return " fullSize"
      }else{
        return ""
      }
    },
   document(){
     console.log("ENV CARD", this.card.id)
     if(this.$store.getters.getEvidence(this.card.id)){
       return this.$store.getters.getEvidence(this.card.id)
     }
    this.$store.dispatch('loadEvidence',this.card.id)
   }
  },
  methods: {
    resizeMap(){
      this.$refs.mapPanel.doResize()
    },
    showMap(){
      this.mapVis=true;
    },
    hideMap(){
      this.mapVis=false;
    },
    viewDoc(){
      this.fullSize=!this.fullSize
    },
    click(){
      this.$emit('click',this.index)
    }
  },
  watch:{
    fullSize(){
      this.$set(this.card,'width',this.docWidth)
      this.$set(this.card,'height',this.docHeight)
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";
.evidenceCard {
  text-align: left;
  min-height: 240px!important;
  top:0px;
  left:0px;
  border: solid 3px #0bf;
  background-color: $glow-bg;
  box-shadow: inset 0px 0px 20px 0px;
  color: #0bf;
  line-height: 30px;
  margin:0px;
  position:relative;


  .drag{
    text-align: center;
   margin-bottom:7px;
    -webkit-box-shadow: inset 0px 0px 20px 2px;
    box-shadow: inset 0px 0px 20px 2px;
    border-bottom: solid 3px #0bf;
    background-color: #003;
    line-height: 24px;
  }
  .drag:active {
     cursor:move;
    cursor: grabbing;
  }
  .drag:hover {
  
    background-color: #00ffff;
    -webkit-box-shadow: inset 0px 0px 20px -5px;
    box-shadow: inset 0px 0px 20px -5px;
    color: #03b;
    border-bottom: solid 3px $glow-text-colour-selected;
 }
}
</style>